import icon from 'vue-svgicon';

icon.register({
    'bold/check-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M23.374.287a1.5 1.5 0 0 0-2.093.345L7.246 20.2l-4.685-4.689a1.5 1.5 0 1 0-2.122 2.121l5.935 5.934a1.525 1.525 0 0 0 2.279-.186l15.066-21a1.5 1.5 0 0 0-.345-2.093z"/>`,
    },
});
